<script setup>
import { reactive } from 'vue';
import { Secretary } from '@/libraries/ClassDefinitions';
import { hospitalDisplayOptions, hospitalValueOptions, departmentDisplayOptions, departmentValueOptions, specializationDisplayOptions, specializationValueOptions } from '@/libraries/AccountData'
import { returnAllUsersByRole, registerUserInformation, editUser } from '@/firebase_files/user_functions';
import router from '@/router';

import FormTextInput from './FormTextInput.vue';
import FormSelect from './FormSelect.vue';
import PhysicianMultiSelectVue from './PhysicianMultiSelect.vue';
import SpinnerWheel from '@/components/SpinnerWheel.vue';
import { store } from '@/store';





const props = defineProps(['user']);
const emits = defineEmits(['onSubmit']);


const newUser = reactive(new Secretary());

init()
async function init() {

  if (props.user) {
    newUser.name = props.user.name;
    newUser.role = props.user.role;
    newUser.department = props.user.department;
    newUser.hospital = props.user.hospital;
    newUser.assignedPhysicians = props.user.assignedPhysicians;
  }
  const physicians = (await returnAllUsersByRole('physician'))
  initializePhysicianList(physicians); // void that updates state
}

/**
 * Dealing with the physician list and multi-select is tough, so we will keep one
 * list that has the physician properties AND isSelected, and that will be passed in and out 
 * of the multi select component as a reference.
 */
function initializePhysicianList(physicians) {
  newUser.physicians = physicians.map((d) => {
    return { isSelected: false, 
      name: d.name, 
      uid:d.uid,
      cpso:d.cpso,
      department: d.department,
      hospital: d.hospital,
    };
  });
}

function getAssignedPhsyicians() {
  const valid = newUser.physicians.filter((d) => d.isSelected);
  let returnArray =[];
  valid.forEach((d) => { // verbose way of remoive .isSelected
    returnArray.push({
      name: d.name,
      uid: d.uid,
      cpso: d.cpso,
      department: d.department,
      hospital: d.hospital,
    })}
    );
  return returnArray;
}

async function submitSecretary() {
  const n = newUser;
  newUser.assignedPhysicians = getAssignedPhsyicians();
  if (props.user && !store.newUser){
    await editUser(newUser);
    router.push('/dashboard');

  }
  else{
    await registerUserInformation(newUser);
    store.userRole = 'secretary'
    store.newUser = false;
    router.push('/dashboard');
  }
  
}
</script>
<template>
  <div v-if="!newUser.physicians">
    <SpinnerWheel />
    <p class="wait-message">Fetching data...</p>
  </div>
  <div v-else class="form-container">

    <h2 class="user-title">Secretary</h2>
    <FormTextInput :input="newUser.name" :promptText="'Name'" @onChange="(d) => newUser.name = d" />

    <FormSelect :input="newUser.hospital" :promptText="'Hospital'" :displayOptions="hospitalDisplayOptions"
      :valueOptions="hospitalValueOptions" @onChange="(d) => newUser.hospital = d" />
    <FormSelect :input="newUser.department" :promptText="'Department'" :displayOptions="departmentDisplayOptions"
      :valueOptions="departmentValueOptions" @onChange="(d) => newUser.department = d" />

    <PhysicianMultiSelectVue :data="newUser.physicians" />

    <div class="submit-button">
      <button @click="submitSecretary">Submit</button>
    </div>

  </div>
</template>

<style scoped lang="scss">
@import "@/styles/registration.scss";
</style>
